<template lang="html">
  <section
    v-if="items.length"
    class="new-section__container w-full"
    aria-labelledby="new-section-heading"
  >
    <div class="new-section mx-auto w-full max-w-(--ui-container) px-3 py-6 sm:px-6 sm:py-8">
      <div class="new-section__header mb-6">
        <h2
          id="new-section-heading"
          class="new-section__title text-2xl font-bold tracking-tight text-highlighted sm:text-3xl"
        >
          Новинки
        </h2>
      </div>

      <div
        class="new-section__list grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-3 sm:gap-3 md:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] md:gap-4"
      >
        <ProductCard
          v-for="product in items"
          :key="product.id"
          :value="product"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
/**
 * Home “Новинки” row — latest products by updated date.
 * Omitted when the feed is empty (no empty-state placeholder).
 */
import {
  SortDirection,
  type ProductsListGetRequestQuery,
} from '@repo/api/web/models'

import ProductCard from '../Card/ProductCard.vue'

const { service } = useProducts()
const { data: products } = await useAsyncData('NewProductsSection', () =>
  service.list({
    Limit: 12,
    SortField: 'updated',
    SortDirection: SortDirection.DESC,
  } as ProductsListGetRequestQuery),
)

const items = computed(() => products.value?.items || [])
</script>

<style lang="css" scoped>
.new-section__container {
  background:
    url('/catalog/brand/patternLeft.svg') left / contain repeat-y,
    url('/catalog/brand/patternRight.svg') right / contain repeat-y;
}
</style>
